import React, { useState, useEffect } from 'react';
import styled, { keyframes } from 'styled-components';
import MetaTags from 'react-meta-tags';
import Header from './comp/Header';
import Slider from './comp/Slider';
import Vision from './comp/Vision';
import About from './comp/About';
import Contact from './comp/Contact';
import Services from './comp/Services';
import Journey from './comp/Journey';
import Footer from './comp/Footer';
import API from '../../api';

// Animated gradient for loader
const gradientAnimation = keyframes`
  0% { background-position: 0% 50%; }
  50% { background-position: 100% 50%; }
  100% { background-position: 0% 50%; }
`;

const LoaderWrapper = styled.div`
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 22px;
  font-weight: 600;
  background: linear-gradient(-45deg, #150080, #4f00ff, #8a2be2, #5f00ff);
  background-size: 400% 400%;
  color: #fff;
  animation: ${gradientAnimation} 8s ease infinite;
`;

const SectionWrapper = styled.div`
  opacity: 0;
  transform: translateY(30px);
  animation: fadeIn 1s forwards;
  animation-delay: ${({ delay }) => delay || '0s'};
  @keyframes fadeIn {
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
`;

const Home = () => {
  const [appData, setAppData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  const readAppData = async () => {
    try {
      setIsLoading(true);
      const response = await API.get(`/configurations/meta-details`);
      if (response.data) setAppData(response.data);
    } catch (error) {
      console.error('Error fetching app data:', error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    readAppData();
  }, []);

  if (isLoading) {
    return <LoaderWrapper>Loading...</LoaderWrapper>;
  }

  return (
    <>
      <MetaTags>
        <link
          href="https://fonts.googleapis.com/css?family=Poppins:200,300,400,500,600,700,800,900&display=swap"
          rel="stylesheet"
        />
        <link rel="stylesheet" href="css/bootstrap.min.css" />
        <link rel="stylesheet" href="css/normalize.css" />
        <link rel="stylesheet" href="css/style.css" />
        <link rel="stylesheet" href="css/responsive.css" />
        <link rel="stylesheet" href="css/color/color1.css" />
      </MetaTags>

      <SectionWrapper delay="0s">
        <Header {...appData} />
      </SectionWrapper>
      <SectionWrapper delay="0.2s">
        <Slider {...appData} />
      </SectionWrapper>
      <SectionWrapper delay="0.4s">
        <Vision {...appData} />
      </SectionWrapper>
      <SectionWrapper delay="0.6s">
        <About {...appData} />
      </SectionWrapper>
      <SectionWrapper delay="0.8s">
        <Contact {...appData} />
      </SectionWrapper>
      <SectionWrapper delay="1s">
        <Services />
      </SectionWrapper>
      <SectionWrapper delay="1.2s">
        <Journey />
      </SectionWrapper>
      <SectionWrapper delay="1.4s">
        <Footer {...appData} />
      </SectionWrapper>
    </>
  );
};

export default Home;
